import createFreq from './component/createFreq'
import editFreq from './component/editFreq'
export default {
  className: 'frequency',
  defaultOrder: '-weight',
  render (record) {
    return record && record.startTime + '-' + record.endTime
  },
  fields: [
    'price',
    'startTime',
    'endTime'
  ],
  action: { // 设置action，可以自行调整
    export: false,
    create: {
      text: '新建',
      type: 'list',
      component: createFreq
    },
    edit: {
      text: '编辑',
      type: 'row',
      component: editFreq
    },
    sorter: {
      type: 'list',
      icon: 'swap',
      text: '排序',
      component: 'akModelSorter'
    }
  }
}
